import htmxModule from "htmx.org"
import "~/controllers"
import "~/lib/htmx-feedback"

const htmx = window.htmx ?? htmxModule

function initHtmxViewTransitions() {
  if (!htmx || !document.body) return

  const isBoostEnabled = document.body.getAttribute("hx-boost") === "true"
  const supportsViewTransitions = typeof document.startViewTransition === "function"
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  htmx.config.globalViewTransitions = isBoostEnabled && supportsViewTransitions && !prefersReducedMotion
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHtmxViewTransitions, {
    once: true
  })
} else {
  initHtmxViewTransitions()
}

// Костыль для селектов при использовании HTMX в Firefox
function isFirefox() {
  return navigator.userAgent.includes("Firefox")
}

document.body.addEventListener("htmx:afterSwap", (event) => {
  if (!isFirefox()) return

  event.target.querySelectorAll("select").forEach((select) => {
    const selectedValue = select.value
    const newSelect = select.cloneNode(true)
    select.parentNode.replaceChild(newSelect, select)
    newSelect.value = selectedValue
  })
})
